import {
  Affiliation,
  Department,
  DepartmentGroup,
  IDepartmentRepository,
} from "../../../domain/department";
import {
  AuthenticatedCachedRepository,
  AuthenticatedHttpClient,
} from "../..";
import {
  IDepartmentBean,
  IDepartmentGroupBean,
  IStaffDepartmentBean,
} from "./beans";

export class DepartmentRepository extends AuthenticatedCachedRepository<string, Department> implements IDepartmentRepository {
  constructor(getToken: () => string) {
    super(new AuthenticatedHttpClient(getToken), DepartmentRepository.createCache);
  }

  private static async createCache(client: AuthenticatedHttpClient): Promise<Department[]> {
    const url = "/api/departments";
    const result = await client.get(url);
    return DepartmentRepository.toDepartments(result.data);
  }

  private static toAffiliation(bean: IStaffDepartmentBean): Affiliation {
    return new Affiliation(
      DepartmentRepository.toDepartment(bean.mainDepartment),
      DepartmentRepository.toDepartments(bean.departments)
    );
  }

  public static toDepartments(departments: IDepartmentBean[]): Department[] {
    const results: Department[] = [];
    for (const department of departments) {
      results.push(DepartmentRepository.toDepartment(department));
    }
    return results;
  }

  public static toDepartment(bean: IDepartmentBean): Department {
    return bean !== null
      ? Object.freeze(new Department(
          bean.departmentId,
          bean.name,
          bean.shortName,
          !!bean.isDeleted
        ))
      : null; 
  }

  async getUserDepartments(id: string): Promise<Affiliation> {
    if (!id || id === "") { throw new Error("id is empty!!!"); }
    const url = "/api/user/" + id + "/departments";
    const result = await this.get(url);
    console.debug(result.data);

    // TODO:主科と所属診療科を返す
    console.debug("TODO: implement main department return function.");
    const bean = result.data as IStaffDepartmentBean;
    return DepartmentRepository.toAffiliation(bean);
  }

  async saveSelectedDepartment(userCode: string, departmentCode: string): Promise<void> {
    if (!userCode) { throw new Error("userCode is empty!!!"); }
    if (!departmentCode) { throw new Error("departmentCode is empty!!!"); }

    const sendData = {
      token: this.token,
      departmentCode,
    };
    const url = "/api/user/" + userCode + "/selected-department";
    await this.post(url, sendData);
  }

  async getDepartmentGroups(): Promise<DepartmentGroup[]> {
    const url = "/api/department-groups";
    const result = await this.get(url);
    console.debug(result.data);
    return DepartmentRepository.toDepartmentGroups(result.data);
  }

  async getDepartmentGroup(departmentGroupId: string): Promise<DepartmentGroup> {
    const url = "/api/department-group/" + departmentGroupId;
    const result = await this.get(url);
    console.debug(result.data);
    return DepartmentRepository.toDepartmentGroup(result.data);
  }

  public static toDepartmentGroups(beans: IDepartmentGroupBean[]): DepartmentGroup[] {
    if (!beans) { return []; }
    return beans.map(bean => DepartmentRepository.toDepartmentGroup(bean));
  }

  public static toDepartmentGroup(bean: IDepartmentGroupBean): DepartmentGroup {
    if (!bean) { return null; }
    const departments = DepartmentRepository.toDepartments(bean.departments);
    return Object.freeze(new DepartmentGroup(bean.departmentGroupId, bean.name, departments, bean.isDeleted));
  }
}
